function RadioButtonGroup({ setSelectedValue, selectedValue }) {
  // State to keep track of the selected radio button value

  // Handler function to update the state when a radio button is selected
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  return (
    <div className="flex space-x-4">
      <label
        className={`${
          selectedValue === "allPatients" ? "bg-yellow-500" : ""
        } flex items-center mb-2 whitespace-nowrap  hover:cursor-pointer`}
        onClick={handleChange}
      >
        {" "}
        <input
          type="radio"
          value="allPatients"
          className="mr-1 hover:cursor-pointer"
          checked={selectedValue === "allPatients"}
        />
        All Patients
      </label>
      <br />
      <label
        className={`${
          selectedValue === "requisitions" ? "bg-yellow-500" : ""
        } flex items-center mb-2 whitespace-nowrap  hover:cursor-pointer`}
        onClick={handleChange}
      >
        <input
          type="radio"
          value="requisitions"
          className="mr-1 hover:cursor-pointer"
          checked={selectedValue === "requisitions"}
          onChange={handleChange}
        />
        Requisitions
      </label>
      <br />
    </div>
  );
}

export default RadioButtonGroup;
